import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-delete-button-sm',
  templateUrl: './delete-button-sm.component.html',
  styleUrls: ['./delete-button-sm.component.scss']
})
export class DeleteButtonSmComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
